import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	email: {
		id: 'eoc-schedule-common.common.ui.participant-card.contact.email',
		defaultMessage: 'Email',
		description: 'Email Icon Label.',
	},
	accountDeactivated: {
		id: 'eoc-schedule-common.common.ui.participant-card.contact.account-deactivated',
		defaultMessage: 'Account Deactivated',
		description: 'Information text that indicates responder is deactivated.',
	},
	noOneIsOnCall: {
		id: 'eoc-schedule-common.common.ui.participant-card.contact.no-one-is-on-call',
		defaultMessage: 'No one is on-call on this shift.',
		description:
			'Warning text that indicates current responder is deactivated/deleted and no-one is on-call.',
	},
});
